const lightbox = () => {
  const paragraphs = document.querySelectorAll(".paragraph-chart");

  for (const paragraph of paragraphs) {
    const image = paragraph.querySelector(".paragraph-chart-image");
    const overlay = paragraph.querySelector(".lightbox-overlay");
    const lightbox = paragraph.querySelector(".lightbox");

    image.addEventListener("click", () => {
      document.body.style.overflow = "hidden";
      document.body.appendChild(overlay);
      document.body.appendChild(lightbox);
      setTimeout(() => {
        overlay.classList.add("is-active");
        lightbox.classList.add("is-active");
      }, 100);
    });

    overlay.addEventListener("click", () => {
      overlay.classList.remove("is-active");
      lightbox.classList.remove("is-active");
      setTimeout(() => {
        document.body.style.overflow = "auto";
        paragraph.appendChild(overlay);
        paragraph.appendChild(lightbox);
      }, 300);
    });
  }

  const videos = document.querySelectorAll(".article-video");

  for (const video of videos) {
    const overlay = video.querySelector(".lightbox-overlay");
    const lightbox = video.querySelector(".lightbox");

    video.addEventListener("click", () => {
      document.body.style.overflow = "hidden";
      document.body.appendChild(overlay);
      document.body.appendChild(lightbox);
      setTimeout(() => {
        overlay.classList.add("is-active");
        lightbox.classList.add("is-active");
      }, 100);
    });

    overlay.addEventListener("click", () => {
      overlay.classList.remove("is-active");
      lightbox.classList.remove("is-active");
      setTimeout(() => {
        document.body.style.overflow = "auto";
        video.appendChild(overlay);
        video.appendChild(lightbox);
      }, 300);
    });
  }

  const people = document.querySelectorAll(".person");

  for (const person of people) {
    const vcard = person.querySelector(".person-vcard");

    if (!vcard) {
      continue;
    }

    const overlay = person.querySelector(".lightbox-overlay");
    const lightbox = person.querySelector(".lightbox");

    vcard.addEventListener("click", () => {
      document.body.style.overflow = "hidden";
      document.body.appendChild(overlay);
      document.body.appendChild(lightbox);
      setTimeout(() => {
        overlay.classList.add("is-active");
        lightbox.classList.add("is-active");
      }, 100);
    });

    overlay.addEventListener("click", () => {
      overlay.classList.remove("is-active");
      lightbox.classList.remove("is-active");
      setTimeout(() => {
        document.body.style.overflow = "auto";
        person.prependChild(overlay);
        person.prependChild(lightbox);
      }, 300);
    });
  }
};

export default lightbox;
